import { render } from "./LeadSource.vue?vue&type=template&id=5191d4a4&scoped=true"
import script from "./LeadSource.vue?vue&type=script&lang=js"
export * from "./LeadSource.vue?vue&type=script&lang=js"

import "./LeadSource.vue?vue&type=style&index=0&id=5191d4a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5191d4a4"

export default script